<!--
 * @Author: gaoxueting
 * @Date: 2020-06-19 19:12:04
 * @LastEditTime: 2020-07-30 11:42:32
 * @LastEditors: fengzhongmei
 * @Description:
-->
<template>
    <Modal v-model="modal"
           :mask-closable="false"
           :title="$t('绑定弹性IP')"
           @on-cancel="cancel"
           width=720
           class="bind-ip">
        <rcTable ref="selection"
                 :tableAttr="tableAttr"
                 @onSelectChange="onSelectChange"></rcTable>
        <div slot="footer">
            <Button @click="cancel"
                    class="ivu-btn-text">{{$t('取消')}}</Button>
            <Button type="primary"
                    @click="save"
                    :loading="loading">
                <span v-show="!loading">&nbsp;{{$t('确认')}}&nbsp;</span>
                <span v-show="loading">&nbsp;{{$t('确认中')}}&nbsp;</span>
            </Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
import rcTable from '@c/basic/rcTable'
// import { getOne } from '@/service/utils.js'
export default {
    name: 'createvirip',
    props: [],
    components: {
        rcTable
    },
    data () {
        return {
            modal: false,
            loading: false,
            envId: this.$route.query.envId,
            choosed: null,
            rowData: null,
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                height: 200,
                pageData: {
                    show: false
                },
                // isSingleSelect: true,
                columns: [
                    {
                        title: '',
                        key: 'id',
                        width: 50,
                        render: (h, params) => {
                            const id = params.row.id
                            const choosedId = this.choosed.id
                            let flag = false
                            if (choosedId === id) {
                                flag = true
                            } else {
                                flag = false
                            }
                            const self = this
                            return h('div', [
                                h('Radio', {
                                    props: {
                                        value: flag
                                    },
                                    on: {
                                        'on-change': () => {
                                            self.onSelectChange(params.row)
                                        }
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: this.$t('弹性IP'),
                        render: (h, params) => {
                            const txt = params.row.ip
                            return h('div', [
                                h('p', txt)
                            ])
                        }
                    },
                    {
                        title: this.$t('状态'),
                        render: (h, params) => {
                            return h('statusview', {
                                props: {
                                    state: params.row.status.toLowerCase(),
                                    stateName: this.$i18n.t(this.statusList[params.row.status])
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('类型'),
                        render: (h, params) => {
                            return h('div', [
                                h('p', this.internetChargeType[params.row.internetChargeType])
                            ])
                        }
                    },
                    {
                        title: this.$t('带宽大小'),
                        render: (h, params) => {
                            return h('div', [
                                h('p', params.row.bandWidth)
                            ])
                        }
                    }
                ]
            },
            internetChargeType: {
                PayByBandwidth: this.$t('按固定带宽计费'), // Aliyun
                PayByTraffic: this.$t('按流量计费'), // Aliyun
                'sta per': this.$t('静态BGP,独享带宽'), // HuaweiCloud
                'sta all': this.$t('静态BGP,共享带宽'), // HuaweiCloud
                'mov per': this.$t('动态BGP,独享带宽'), // HuaweiCloud
                'mov all': this.$t('动态BGP,共享带宽'), // HuaweiCloud
                'un per': this.$t('联通,独享带宽'), // HuaweiCloud
                'tel all': this.$t('电信,共享带宽')// HuaweiCloud
            },
            statusList: {
                ACTIVE: '已绑定',
                UNUSED: '未绑定'
            }
        }
    },
    methods: {
        onSelectChange (rows) {
            this.choosed = rows
        },
        // 打开弹出框
        openModal (row) {
            this.modal = true
            this.rowData = row
            this.axios.get(this.urlFormat(API.PORTS_BIND_IPLIST, false), {
                params: {
                    cloudEnvId: this.envId,
                    portId: row.id
                }
            }).then(res => {
                this.tableAttr.source.tableData.totalRows = res.length
                this.tableAttr.source.tableData.dataList = res
                this.$refs.selection && this.$refs.selection.init()
                this.choosed = this.tableAttr.source.tableData.dataList[0]
            })
        },
        // 取消
        cancel () {
            this.modal = false
        },
        // 表单提交
        save () {
            const params = {
                portId: this.rowData.id,
                floatingIpId: this.choosed.id
            }
            this.axios.post(this.urlFormat(API.POST_ATTACH_FLOATIP, false), params).then(res => {
                if (res.status) {
                    this.cancel()
                    this.$emit('refresh')
                }
                this.loading = false
            }).catch(e => {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less">
.bind-ip {
    .ivu-modal-body {
        max-height: 450px;
        overflow: hidden;
        overflow-y: auto;
        padding-left: 20px;
    }
}
</style>
